'use strict';

const { h } = require('phy');

const Card = require('../../../components/card/card');
const Legal = require('./legal');

function getOfferImageSize(isTouch, onBrowser) {
  if (isTouch) {
    let imageWidth = 297;
    if (onBrowser) {
      const { offsetWidth } = document.querySelector(
        '.coupons-grid-content .column'
      );
      if (offsetWidth) {
        imageWidth = offsetWidth;
      }
    }

    return [`w_${imageWidth},h_190,c_fill`];
  }

  return ['w_248,h_138,c_fill'];
}

function CouponsGridRow({
  item,
  routes,
  innerWidth,
  isTouch,
  customBreakoutType,
  customRowType,
}) {
  switch (item.type) {
    case customBreakoutType:
      return item.children;
    case customRowType:
      return h(
        '.page-container',
        h('.row', h('.twelve.column', item.children))
      );
    default:
      return h(
        '.page-container',
        h(
          '.row.coupons-grid-content',
          item.children.map(child =>
            h(
              '.three.column',
              Card({
                routes,
                item: child,
                isTouch,
                sizes: {
                  offer: getOfferImageSize(isTouch, innerWidth),
                  logo: { width: 68, height: 68 },
                },
                className: 'card',
                child: Legal({ item: child, routes, isCard: true }),
                tag: 'div',
                lazy: true,
              })
            )
          )
        )
      );
  }
}

module.exports = CouponsGridRow;
